<script lang="ts" setup>
import { useScreenSize } from '@/composables/screen-size'
import {
  AppBlock,
  AppSection,
  AppSkeleton,
  HeadingSkeleton,
  ImageSkeleton,
  ParagraphSkeleton
} from 'lilasia-ui'

const { isMobile } = useScreenSize()
</script>

<template>
  <AppSection
    :fluid="isMobile"
    :no-gap="isMobile"
  >
    <div class="md:grid md:grid-cols-5 md:items-start md:gap-24">
      <div class="w-full md:col-span-3">
        <AppSkeleton class="aspect-square w-full rounded-[0] md:rounded-8 lg:rounded-16" />
        <div
          class="mt-24"
          :class="isMobile ? 'container mx-auto' : ''"
        >
          <div class="flex flex-col gap-16">
            <div class="flex flex-col gap-8">
              <div class="text-14 font-600 leading-20 text-black-60">
                <AppSkeleton class="h-12 w-60" />
              </div>
              <div class="text-20 font-500">
                <HeadingSkeleton />
              </div>
              <div class="text-32 font-700 leading-[42px] text-blue-100">
                <HeadingSkeleton class="w-[120px]" />
              </div>
              <div class="flex items-center gap-8">
                <AppSkeleton class="h-12 w-60" />
                <AppSkeleton class="h-12 w-60" />
              </div>
            </div>
            <div class="flex flex-col gap-8">
              <div class="leadng-20 text-14 font-500">
                <AppSkeleton class="h-12 w-60" />
              </div>
              <ParagraphSkeleton :rows="5" />
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="!isMobile"
        class="sticky top-[96px] inline-block md:col-span-2 lg:top-[112px]"
      >
        <div class="flex flex-col md:gap-16 lg:gap-24">
          <AppBlock bordered>
            <div class="p-16">
              <div class="flex items-center gap-8">
                <ImageSkeleton class="h-[60px] w-[60px]" />
                <div class="space-y-4">
                  <AppSkeleton class="h-20 w-[120px]" />
                  <AppSkeleton class="h-20 w-60" />
                </div>
              </div>
            </div>
            <AppSkeleton class="h-[72px] w-full rounded-[0] rounded-b-8 md:h-[96px]" />
          </AppBlock>

          <AppBlock bordered>
            <div class="p-16">
              <AppSkeleton class="h-20 w-[120px]" />
            </div>
            <div class="p-16">
              <AppSkeleton class="h-40 w-full" />
            </div>
            <div class="p-16">
              <div class="flex items-center justify-between gap-16">
                <AppSkeleton class="h-40 w-full" />
                <AppSkeleton class="h-40 w-full" />
              </div>
            </div>
            <div class="p-16">
              <AppSkeleton class="h-40 w-full" />
            </div>
            <div class="p-16">
              <AppSkeleton class="h-40 w-full" />
            </div>
          </AppBlock>
        </div>
      </div>
    </div>
  </AppSection>
</template>
